import { cn } from '@utils/helpers'

const variants = {
  primary: 'text-primary-800 hover:bg-primary-50 focus:ring-primary-500',
  secondary: 'text-slate-600 hover:bg-slate-100 focus:ring-slate-400',
  danger: 'text-red-600 hover:bg-red-50 focus:ring-red-500',
  ghost: 'text-slate-400 hover:bg-slate-100 hover:text-slate-600 focus:ring-slate-400',
}

const sizes = {
  sm: 'p-1',
  md: 'p-2',
  lg: 'p-3',
}

export const IconButton = ({
  children,
  variant = 'ghost',
  size = 'md',
  disabled = false,
  className = '',
  type = 'button',
  onClick,
  ...props
}) => {
  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      className={cn(
        'inline-flex items-center justify-center rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed',
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {children}
    </button>
  )
}
